<template>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <form class="needs-validation" novalidate="" @submit.prevent="validationSubmit">
        <div class="modal-header">
          <h5 class="modal-title">카드 정보</h5>
          <button :id="`cardCloseModal${orderId}`" class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="col-11 d-flex align-items-center justify-content-center mt-2">
            <div class="col-12 d-flex align-items-center justify-content-start">
              <div v-if="ccardInfoClone.basicPaymentAmount" class="col-2">
                <span class="">기본비</span>
              </div>
              <div v-if="ccardInfoClone.basicPaymentAmount" class="col-2">
                <input v-model="ccardInfoClone.basicPaymentAmount" @input="handleBasicPaymentAmount" class="form-control btn-square" type="text" :readOnly="isRead">
                <!-- <div class="invalid-feedback text-start" v-if="error.basicDesc">{{error.basicDesc}}</div> -->
              </div>
              <div v-if="ccardInfoClone.optionPaymentAmount" class="col-2">
                <span class="">추가비</span>
              </div>
              <div v-if="ccardInfoClone.optionPaymentAmount" class="col-2">
                <input v-model="ccardInfoClone.optionPaymentAmount" @input="handleOptionPaymentAmount" class="form-control btn-square" type="text" :readOnly="isRead">
              </div>
              <div v-if="ccardInfoClone.uninstallPaymentAmount" class="col-2">
                <span class="">탈거비</span>
              </div>
              <div v-if="ccardInfoClone.uninstallPaymentAmount" class="col-2">
                <input v-model="ccardInfoClone.uninstallPaymentAmount" @input="handleUninstallPaymentAmount" class="form-control btn-square" type="text" :readOnly="isRead">
              </div>
            </div>
          </div>
          <div class="col-11 d-flex align-items-center justify-content-center mt-2">
            <div class="col-2">
              <span class="">내용</span>
            </div>
            <div class="col-10">
              <input v-model="ccardInfoClone.desc" class="form-control btn-square col-7" type="text" :readOnly="isRead">
              <!-- <div class="invalid-feedback text-start" v-if="error.basicDesc">{{error.basicDesc}}</div> -->
            </div>
          </div>
          <!-- <div class="col-12 d-flex align-items-center justify-content-center mt-2">
            <div class="col-2">
              <span class="">금액</span>
            </div>
            <div class="col-9">
              <input v-model="ccardInfoClone.amount" @input="handleAmount" class="form-control btn-square col-7" type="text" :readOnly="isRead">
            </div>
          </div> -->
          <div class="col-11 d-flex align-items-center justify-content-center mt-2">
            <div class="col-2">
              <span class="">카드사명</span>
            </div>
            <div class="col-10">
              <input v-model="ccardInfoClone.cardCompany" class="form-control btn-square col-7" type="text" :readOnly="isRead">
              <!-- <div class="invalid-feedback text-start" v-if="error.basicCardCompany">{{error.basicCardCompany}}</div> -->
            </div>
          </div>
          <div class="col-11 d-flex align-items-center justify-content-center mt-2">
            <div class="col-2">
              <span class="">카드번호</span>
            </div>
            <div class="col-10">
              <input maxlength="19" v-model="ccardInfoClone.cardNo" @input="handleCardNo" class="form-control btn-square col-7" type="text" :readOnly="isRead">
              <!-- <div class="invalid-feedback text-start" v-if="error.basicCardNo">{{error.basicCardNo}}</div> -->
            </div>
          </div>
          <div class="col-11 d-flex align-items-center justify-content-center mt-2">
            <div class="col-2">
              <span class="">유효기간</span>
            </div>
            <div class="col-10">
              <input maxlength="5" placeholder="숫자만 입력하세요. 월/년" v-model="ccardInfoClone.cardValidPeriod" @input="handleCardValidPeriod" class="form-control btn-square col-7" type="text" :readOnly="isRead">
              <!-- <div class="invalid-feedback text-start" v-if="error.basicCardValidPeriod">{{error.basicCardValidPeriod}}</div> -->
            </div>
          </div>
          <div class="col-11 d-flex align-items-center justify-content-center mt-2">
            <div class="col-2">
              <span class="">승인번호</span>
            </div>
            <div class="col-10">
              <input maxlength="8" placeholder="숫자만 입력하세요. 8자리" v-model="ccardInfoClone.txApprovalNo" class="form-control btn-square col-7" type="text" :readOnly="isRead">
              <!-- <div class="invalid-feedback text-start" v-if="error.basicTxApprovalNo">{{error.basicTxApprovalNo}}</div> -->
            </div>
          </div>
          <div class="col-11 d-flex align-items-center justify-content-center mt-2">
            <div class="col-2">
              <span class="">승인일자</span>
            </div>
            <div class="col-10">
              <input maxlength="5" placeholder="숫자만 입력하세요. 월/년" v-model="ccardInfoClone.approvalDateTime" @input="handleApprovalDateTime" class="form-control btn-square col-7" type="text" :readOnly="isRead">
              <!-- <div class="invalid-feedback text-start" v-if="error.basicApprovalDateTime">{{error.basicApprovalDateTime}}</div> -->
            </div>
          </div>
          <div class="col-11 d-flex align-items-center justify-content-center mt-2">
            <div class="col-2">
              <span>비고</span>
            </div>
            <div class="col-10">
              <input v-model="ccardInfoClone.remark" @input="checkRemarkByte" class="form-control btn-square col-7" type="text" placeholder="" :readOnly="isRead">
            </div>
          </div>
        </div>
        <div v-if="!isRead" class="modal-footer d-flex justify-content-center">
          <button class="btn btn-secondary" type="submit">수정</button>
        </div>
      </form>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, computed, defineProps, toRefs, onUnmounted, watch, defineEmits } from 'vue';
import useSettleManagement from '@/composables/settleManagement'
import commonApi from '@/composables/commonApi'
import PostCode from '@/components/PostCode.vue'
import { useRouter } from 'vue-router'
import { useLoginAuth } from '@/stores/LoginAuthStore';
import Swal from 'sweetalert2';
const router = useRouter();
const LoginAuthStore = useLoginAuth(router)
const props = defineProps({
  orderId: {
    type: Number,
    required: true,
  },
  ccardInfo: {
    required: true,
  },
  isRead: {
    type: Boolean,
    required: false,
  },
  searchType: {
    type: String,
    required: false,
  }
});
const { orderId, ccardInfo, isRead, searchType } = toRefs(props);
const { updatePayment } = useSettleManagement(LoginAuthStore);
const { loadCommonCode } = commonApi(LoginAuthStore);
const ccardInfoClone = ref({});
const workTypeListRef = ref([])
const progressListRef = ref([])
const vhcCatCodeListRef = ref([])
const paymentCodeRef = ref([]);
const inChargePersonRef = ref({});
const path = ref(router.currentRoute.value.path);
const isCard = path.value.includes('card');
const isOpenModal = ref(false);
const emit = defineEmits(['listCard']);

onMounted(() => {
  const cardModalEl = document.getElementById(`card${orderId.value}`);
  cardModalEl.addEventListener('shown.bs.modal', async () => {
    if (!isOpenModal.value) {
      isOpenModal.value = true;
      ccardInfoClone.value = {...ccardInfo.value};
      ccardInfoClone.value.basicPaymentAmount = comma(uncomma(ccardInfoClone.value.basicPaymentAmount))
      ccardInfoClone.value.optionPaymentAmount = comma(uncomma(ccardInfoClone.value.optionPaymentAmount))
      ccardInfoClone.value.uninstallPaymentAmount = comma(uncomma(ccardInfoClone.value.uninstallPaymentAmount))
    }
  })
  cardModalEl.addEventListener('hidden.bs.modal', async () => {
  isOpenModal.value = false;
  ccardInfoClone.value = {};
  cardModalEl.removeEventListener('shown.bs.modal', async () => {
      if (!isOpenModal.value) {
        isOpenModal.value = true;
        ccardInfoClone.value = {...ccardInfo.value};
        ccardInfoClone.value.basicPaymentAmount = comma(uncomma(ccardInfoClone.value.basicPaymentAmount))
        ccardInfoClone.value.optionPaymentAmount = comma(uncomma(ccardInfoClone.value.optionPaymentAmount))
        ccardInfoClone.value.uninstallPaymentAmount = comma(uncomma(ccardInfoClone.value.uninstallPaymentAmount))
      }
    })
  })
})

const comma = (val) => {
  val = String(val);
  return val.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
}
const uncomma = (val) => {
  val = String(val);
  return val.replace(/[^\d]+/g, '');
}
const handleBasicPaymentAmount = (e) => {
  ccardInfoClone.value.basicPaymentAmount = comma(uncomma(e.target.value))
}
const handleOptionPaymentAmount = (e) => {
  ccardInfoClone.value.optionPaymentAmount = comma(uncomma(e.target.value))
}
const handleUninstallPaymentAmount = (e) => {
  ccardInfoClone.value.uninstallPaymentAmount = comma(uncomma(e.target.value))
}
const conversionCardNo = (cardNo) => {
  const card = cardNo.replace(/[^0-9]/g, "");
  let tmp = '';
  if (card.length < 5) {
    return card
  } else if (card.length < 9) {
    tmp += card.substr(0, 4);
		tmp += '-';
		tmp += card.substr(4);
  } else if (card.length < 13){
		tmp += card.substr(0, 4);
		tmp += '-';
		tmp += card.substr(4, 4);
		tmp += '-';
		tmp += card.substr(8, 4);
		return tmp;
	} else {
		tmp += card.substr(0, 4);
		tmp += '-';
		tmp += card.substr(4, 4);
		tmp += '-';
		tmp += card.substr(8, 4);
		tmp += '-';
		tmp += card.substr(12);
		return tmp;
	}
  return card.replace(/^(\d{4})(\d{4})(\d{4})(\d{4})$/, `$1-$2-$3-$4`);
}
const conversionDate = (rowDate) => {
  const date = rowDate.replace(/[^0-9]/, "");
  return date.replace(/^(\d{2})(\d{2})$/, `$1/$2`);
}
const handleCardNo = (e) => {
  ccardInfoClone.value.cardNo = conversionCardNo(e.target.value)
}
const handleCardValidPeriod = (e) => {
  ccardInfoClone.value.cardValidPeriod = conversionDate(e.target.value)
}
const handleApprovalDateTime = (e) => {
  ccardInfoClone.value.approvalDateTime = conversionDate(e.target.value)
}
const checkRemarkByte = (e) => {
  let limitByte = 240;
  let totalByte = 0;
  let validText = '';
  const remark = e.target.value;
  for (let i = 0; i < remark.length; i++) {
    if (totalByte + 2 <= limitByte) {
      if (remark.charCodeAt(i) > 128) totalByte += 2;
      else totalByte++;
      validText += remark[i];
    } else {
      break;
    }
  }
  ccardInfoClone.value.remark = validText;
}
const validationSubmit = async () => {
  ccardInfoClone.value.basicPaymentAmount = ccardInfoClone.value.basicPaymentAmount ? uncomma(ccardInfoClone.value.basicPaymentAmount) : 0
  ccardInfoClone.value.optionPaymentAmount = ccardInfoClone.value.optionPaymentAmount ? uncomma(ccardInfoClone.value.optionPaymentAmount) : 0
  ccardInfoClone.value.uninstallPaymentAmount = ccardInfoClone.value.uninstallPaymentAmount ? uncomma(ccardInfoClone.value.uninstallPaymentAmount) : 0
  await updatePayment(orderId.value, ccardInfoClone.value);
  const modalClose = document.getElementById(`cardCloseModal${orderId.value}`);
  await modalClose.click();
  await emit('listCard');
}
</script>
<style lang="sass">
</style>